import React, { useState } from "react";
import "./TextCarousel.scss";

const capabilities = [
  "Retail MOQ",
  "Custom labeling",
  "Paper packaging",
  "Bulk cartons",
  "Reliable",
  "Cost-effective",
  "Sample support",
  "Formula options",
];

function TextCarousel() {
  const [isPaused, setIsPaused] = useState(false);

  return (
    <div className={`text-carousel-wrapper mobile-type${isPaused ? " is-paused" : ""}`}>
      <div
        className="text-carousel-viewport"
        role="region"
        aria-label="Klean Leaf capabilities"
        tabIndex={0}
      >
        <div className="text-carousel">
          {[false, true].map((isDuplicate) => (
            <ul
              className="text-carousel-group"
              aria-hidden={isDuplicate ? "true" : undefined}
              key={String(isDuplicate)}
            >
              {capabilities.map((capability) => (
                <li className="carousel-text" key={capability}>
                  <span>{capability}</span>
                  <span className="carousel-star" aria-hidden="true">✦</span>
                </li>
              ))}
            </ul>
          ))}
        </div>
      </div>
      <button
        className="text-carousel-toggle"
        type="button"
        aria-label={isPaused ? "Resume scrolling capabilities" : "Pause scrolling capabilities"}
        onClick={() => setIsPaused((paused) => !paused)}
      >
        <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">
          {isPaused ? (
            <path d="M5 3.5 12 8l-7 4.5Z" />
          ) : (
            <>
              <rect x="4" y="3.5" width="2.5" height="9" rx="0.5" />
              <rect x="9.5" y="3.5" width="2.5" height="9" rx="0.5" />
            </>
          )}
        </svg>
      </button>
    </div>
  );
}

export default TextCarousel;
